/* Product-card membership in the current Shopify cart. No cart writes. */
(() => {
  if (window.lgCartIndicatorLoaded) return;
  window.lgCartIndicatorLoaded = true;
  let productIds = new Set();
  let pending = false;
  let running = null;
  const selector = '[data-lg-cart-product-id]';

  function createBadge(id, extraClass = '') {
    const badge = document.createElement('span');
    badge.className = `lg-cart-indicator ${extraClass}`;
    badge.setAttribute('data-lg-cart-product-id', id);
    badge.setAttribute('role', 'img');
    badge.setAttribute('aria-label', 'In cart');
    badge.tabIndex = 0;
    badge.hidden = true;
    badge.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2 3h2l2.2 11.2a2 2 0 0 0 2 1.6H18a2 2 0 0 0 2-1.6L21.5 7H5"/><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/><path d="m10 10 2 2 4-4"/></svg><span class="lg-cart-indicator__tooltip" aria-hidden="true">In cart</span>';
    return badge;
  }

  function ensureSearch() {
    document.querySelectorAll('.results-block.block-products dt.cs-item[data-id], .results-block.block-products dd[data-id]').forEach(result => {
      if (result.querySelector(selector)) return;
      const id = result.getAttribute('data-id');
      if (!/^\d+$/.test(id || '')) return;
      const image = result.querySelector('a.list-image, .details-top-image');
      if (!image) return;
      image.classList.add('lg-cart-search-image');
      image.appendChild(createBadge(id, 'lg-search-cart-indicator'));
    });
  }

  function ensureCards() {
    // Cloud Search also renders cached Dawn cards outside the Liquid snippet.
    document.querySelectorAll('.product-card-wrapper').forEach(card => {
      const inner = card.querySelector('.card__inner');
      if (!inner || card.querySelector(selector)) return;
      const link = card.querySelector('a[id^="CardLink-"]');
      const id = link?.id.match(/-(\d+)$/)?.[1];
      if (!id) return;
      const badge = createBadge(id);
      inner.appendChild(badge);
    });
  }

  function render(root = document) {
    ensureCards();
    ensureSearch();
    const badges = root.querySelectorAll(selector);
    badges.forEach((badge) => {
      const visible = productIds.has(badge.getAttribute('data-lg-cart-product-id'));
      if (badge.hidden === visible) badge.hidden = !visible;
    });
  }

  function refresh() {
    pending = true;
    if (running) return running;
    running = (async () => {
      while (pending) {
        pending = false;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart.js`, {
            credentials: 'same-origin', cache: 'no-store',
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) throw new Error('Cart unavailable');
          const cart = await response.json();
          if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
          // An update during this request requires a fresh response first.
          if (!pending) {
            productIds = new Set(cart.items.filter(item => Number(item.quantity) > 0)
              .map(item => String(item.product_id)));
            render();
          }
        } catch (_) {
          productIds = new Set();
          render();
        }
      }
    })().finally(() => { running = null; });
    return running;
  }

  function start() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(name =>
      document.addEventListener(name, refresh));
    // Filters, recommendations and quick-add sections can replace the cards.
    new MutationObserver(records => {
      if (records.some(record => record.addedNodes.length)) render();
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pageshow', refresh);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') refresh();
    });
    refresh();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else start();
})();
